'use client';

import { LoaderCircle } from 'lucide-react';
import { Center, Flexbox } from 'react-layout-kit';
import { domId } from '@/lib/dom-id';

import styles from './style.module.css';

interface CircleLoadingProps {
  fullScreen?: boolean;
}

const CircleLoading = ({ fullScreen = false }: CircleLoadingProps) => {
  const loadingContent = (
    <Flexbox align={'center'} gap={8}>
      <div>
        <LoaderCircle className={styles.spinner} size={24} />
      </div>
    </Flexbox>
  );

  if (fullScreen) {
    return (
      <div
        aria-busy="true"
        data-testid={domId('div', 'app-loading')}
        role="status"
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          width: '100vw',
          height: '100vh',
          backgroundColor: 'rgba(255, 255, 255, 0.95)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 9999,
          backdropFilter: 'blur(4px)',
          WebkitBackdropFilter: 'blur(4px)', // Safari support
        }}
      >
        {loadingContent}
      </div>
    );
  }

  return (
    <Center height={'100%'} width={'100%'}>
      {loadingContent}
    </Center>
  );
};

export default CircleLoading;
